'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('onyxReadingRoomApp.deviceconfigs.edit', [])
  .controller('DeviceConfigsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/edit/index.js